var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Checkbox',{staticClass:"conduct-inspections__checkbox",attrs:{"size":"41","checked":_vm.item.response},on:{"input":_vm.handleInput}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }